import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e8910ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "user-nav" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "user-info-name" }
const _hoisted_6 = { class: "user-info-uid" }
const _hoisted_7 = {
  key: 0,
  class: "user-info-uid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "user-nav-title" }, "账号管理", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-right" }, null, -1))
const _hoisted_11 = { class: "user-page" }

import { computed, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { NavConfig, UserInfo } from '@/types'
import { useRoute, useRouter } from 'vue-router'
import avatar from '@/assets/images/header.jpg'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const navList = [
  {
    title: '账号安全',
    url: '/user/binding'
  },
  {
    title: '个人信息',
    url: '/user/profile'
  }
]

const store = useStore()
const router = useRouter()
const route = useRoute()
const activeIndex = ref(0)

const userInfo = computed<UserInfo>(() => {
  return store.getters.userInfo
})

const handleNavClick = (item: NavConfig) => {
  router.push(item.url as string)
}

watchEffect(() => {
  const findIndex = navList.findIndex(item => item.url === route.path)
  activeIndex.value = findIndex !== -1 ? findIndex : 0
})


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: userInfo.value.avatar || _unref(avatar),
          alt: "",
          class: "user-info-avatar"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(userInfo.value.username) + " ", 1),
          _createVNode(_component_el_tag, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode("ID: " + _toDisplayString(userInfo.value.id), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_tag, null, {
            default: _withCtx(() => [
              _createTextVNode("积分: " + _toDisplayString(userInfo.value.points), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tag, null, {
            default: _withCtx(() => [
              _createTextVNode("经验: " + _toDisplayString(userInfo.value.experience), 1)
            ]),
            _: 1
          })
        ]),
        (userInfo.value.is_superuser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_tag, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode("管理员（超级用户）")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("dl", null, [
        _hoisted_8,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
          return _createElementVNode("dd", {
            key: index,
            class: _normalizeClass([{
            active: activeIndex.value==index
          }, "user-nav-item"]),
            onClick: ($event: any) => (handleNavClick(item))
          }, [
            _createTextVNode(_toDisplayString(item.title) + " ", 1),
            _hoisted_10
          ], 10, _hoisted_9)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})